(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Failed');
      return res.json();
    })
    .then(function() {
      btn.textContent = 'Added!';
      setTimeout(function() { btn.textContent = btn.dataset.originalText || 'Add to Cart'; btn.disabled = false; }, 1500);
      // Update cart count
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
      });
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() { btn.textContent = btn.dataset.originalText || 'Add to Cart'; btn.disabled = false; }, 1500);
    });
  });

  // Store original text
  document.querySelectorAll('[data-quick-add]').forEach(function(btn) {
    btn.dataset.originalText = btn.textContent.trim();
  });
})();
